/* eslint-disable @typescript-eslint/no-empty-function */
'use client'

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import parseSearchForHybrid from './parseSearchForHybrid'

export default async function goToSearch(
  router: AppRouterInstance,
  queryString: string,
  revalidatePath: (url: string) => Promise<void> = async () => {}
) {
  const { push } = router

  const parsedSearch = parseSearchForHybrid(queryString)

  await revalidatePath(parsedSearch.split('?')[0])
  push(parsedSearch)
}
